import axios from "axios";

export default function deleteAuthorizationToken() {
    delete axios.defaults.headers.common["Authorization"];
}
